import React from 'react'
import './Header.css'
import WlHeader from '../../../components/Header'
import {
    DeleteDisableIcon,
    AddIcon,
    DeleteableIcon,
} from '../../../conf/images'

interface HeaderProps {
    onDelete?: () => void
    onAdd?: () => void
    deleteable?: boolean
    isDeletting?: boolean
    onDeleteComplete?: () => void
}
const Header: React.FC<HeaderProps> = (props) => {
    const {
        onAdd = () => undefined,
        onDelete = () => undefined,
        deleteable = false,
        isDeletting,
        onDeleteComplete = () => undefined,
    } = props
    return (
        <WlHeader title='我的知识' className='knowledge-header'>
            <div className='options'>
                {!isDeletting ? (
                    <>
                        <span
                            className='action delete'
                            onClick={(e) => {
                                deleteable && onDelete()
                            }}
                        >
                            {!deleteable ? (
                                <img src={DeleteDisableIcon} alt='icon' />
                            ) : (
                                <img src={DeleteableIcon} alt='icon' />
                            )}
                        </span>
                        <span
                            className='action add'
                            onClick={(e) => {
                                onAdd()
                            }}
                        >
                            <img src={AddIcon} alt='icon' />
                        </span>
                    </>
                ) : (
                    <span
                        className='action complete'
                        onClick={onDeleteComplete}
                    >
                        完成
                    </span>
                )}
            </div>
        </WlHeader>
    )
}

export default Header
